
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('conversation-chat-2')]),_c('path',{attrs:{"d":"M23.25,13.5A5.249,5.249,0,0,0,18,8.25H15a5.25,5.25,0,0,0,0,10.5h.75l4.5,4.5V18.226A5.237,5.237,0,0,0,23.25,13.5Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M6.75,12.75l-3,3V10.726A5.239,5.239,0,0,1,6,.75H9A5.252,5.252,0,0,1,14.033,4.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    